import { useEffect, useState } from 'react'
import { AutoComplete, Form } from 'antd'
import { getMunicipios } from '@/api/municipios'
import { semAcento } from '@/lib/formatters'

interface MunicipioAutoCompleteProps {
  uf: string
  value: string
  onChange: (municipio: string) => void
  label?: string
  size?: 'middle' | 'large'
  erro?: string
  formItemClassName?: string
}

export function MunicipioAutoComplete({
  uf,
  value,
  onChange,
  label = 'Município',
  size = 'middle',
  erro,
  formItemClassName,
}: MunicipioAutoCompleteProps) {
  const municipios = useMunicipiosDaUf(uf)
  const opcoes = filtrarPorTrechoDigitado(municipios, value)

  return (
    <Form.Item
      label={label}
      className={formItemClassName}
      validateStatus={erro ? 'error' : ''}
      help={erro}
    >
      <AutoComplete
        value={value}
        onChange={onChange}
        options={opcoes.map((municipio) => ({ value: municipio }))}
        size={size}
        placeholder={uf ? 'Digite o município' : 'Selecione a UF primeiro'}
        disabled={!uf}
      />
    </Form.Item>
  )
}

function useMunicipiosDaUf(uf: string): string[] {
  const [municipios, setMunicipios] = useState<string[]>([])

  useEffect(() => {
    if (!uf) {
      setMunicipios([])
      return
    }
    getMunicipios(uf)
      .then((lista) => setMunicipios(lista.map((municipio) => municipio.nome)))
      .catch(() => setMunicipios([]))
  }, [uf])

  return municipios
}

const LIMITE_DE_SUGESTOES = 50

function filtrarPorTrechoDigitado(municipios: string[], trecho: string): string[] {
  const procurado = semAcento(trecho)
  if (!procurado) return municipios.slice(0, LIMITE_DE_SUGESTOES)
  return municipios
    .filter((municipio) => semAcento(municipio).includes(procurado))
    .slice(0, LIMITE_DE_SUGESTOES)
}
